import {on} from '../helpers/utils';
import cssClasses from '../helpers/cssClasses';

// DOM Selectors
const selectors = {
  container: '[js-readmore="container"]',
  content: '[js-readmore="content"]',
  trigger: '[js-readmore="trigger"]',
};

export default () => {
  // Node selectors
  const nodeSelectors = {
    container: document.querySelector(selectors.container),
    containerExpand: document.querySelector(selectors.content),
    trigger: document.querySelector(selectors.trigger),
  };

  // Set listeners
  function setListeners() {
    if (!nodeSelectors.trigger) {
      return;
    }
    on('click', nodeSelectors.trigger, (event) => handleToggle(event));
  }

  // Open + Close toggles
  function handleToggle(event) {
    event.preventDefault();

    if (nodeSelectors.trigger.classList.contains(cssClasses.active)) {
      removeActiveState();
      removeHeight();
    } else {
      const anchor = document.querySelector('#wyli');
      anchor.scrollIntoView({block: 'start'});
      addActiveState();
      addHeight();
    }
  }

  function addActiveState() {
    nodeSelectors.container.classList.add(cssClasses.active);
    nodeSelectors.trigger.classList.add(cssClasses.active);
  }

  function addHeight() {
    const {clientHeight} = document.querySelector('[js-readmore="content"]');
    nodeSelectors.container.setAttribute('style', `height:${clientHeight}px`);
  }

  function jumpToTop() {
    document.getElementById('wyli').scrollIntoView({behavior: 'smooth'});
  }

  function removeActiveState() {
    nodeSelectors.container.classList.remove(cssClasses.active);
    nodeSelectors.trigger.classList.remove(cssClasses.active);
    jumpToTop();
  }

  function removeHeight() {
    nodeSelectors.container.setAttribute('style', `height: "inherit"`);
  }

  function init() {
    setListeners();
  }

  // Public interface
  return Object.freeze({
    init,
  });
};
